import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Pencil, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from './ui/alert-dialog';
import { SeriesScopeChoice } from './AppointmentEditDialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const CALENDAR_EDIT_ROLES = ['system_admin', 'executive', 'operations_manager'];

// Edit / Delete for an appointment on the Management Calendar (management roles only).
export const CalendarAppointmentActions = ({ event, role, onEdit, onDeleted }) => {
  const [confirming, setConfirming] = useState(false);
  const [scope, setScope] = useState('one');
  const [deleting, setDeleting] = useState(false);
  if (!CALENDAR_EDIT_ROLES.includes(role) || event.event_type !== 'appointment') return null;

  const remove = async () => {
    setDeleting(true);
    try {
      const res = await axios.delete(`${API}/management-calendar/appointments/${event.id}`, { params: { scope } });
      toast.success(res.data.message);
      setConfirming(false);
      onDeleted();
    } catch (e) {
      toast.error(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Failed to delete appointment');
    } finally { setDeleting(false); }
  };

  return (
    <div className="flex gap-2 pt-2">
      <Button variant="outline" size="sm" onClick={() => onEdit(event)} data-testid="calendar-appointment-edit-btn"><Pencil className="w-4 h-4 mr-1" />Edit</Button>
      <Button variant="outline" size="sm" className="text-red-600 hover:text-red-700" onClick={() => { setScope('one'); setConfirming(true); }} data-testid="calendar-appointment-delete-btn">
        <Trash2 className="w-4 h-4 mr-1" />Delete
      </Button>
      <AlertDialog open={confirming} onOpenChange={setConfirming}>
        <AlertDialogContent data-testid="calendar-appointment-delete-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Delete this appointment?</AlertDialogTitle>
            <AlertDialogDescription>
              "{event.title}" will be removed everywhere in MyHELP, including the case's appointments and the management calendar. This cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          {event.series_id && <SeriesScopeChoice value={scope} onChange={setScope} verb="Delete" testid="delete-appointment-scope" />}
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="calendar-appointment-delete-cancel">Keep Appointment</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); remove(); }} disabled={deleting} className="bg-red-600 hover:bg-red-700" data-testid="calendar-appointment-delete-confirm">
              {deleting && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Delete Everywhere
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
